import { useEffect } from "react";

// Запирает прокрутку страницы на время, пока открыто модальное окно.
//
// На телефоне страницу прокручивает не body, а сам .app-root: он стоит
// position: fixed на весь экран со своей прокруткой (см. index.css). Поэтому
// запирается и он — через setProperty с important, потому что в таблице
// стилей его overflow тоже стоит с important, и обычный inline-стиль его не
// перебивает. Body при этом фиксируется на месте с сохранением положения —
// для стола и на случай, если корень когда-нибудь перестанет быть скроллером.
let locks = 0;
let saved = null;

const PHONE_ROOT_SELECTOR = ".app-root.phone-view";

export const lockBodyScroll = () => {
  if (typeof document === "undefined") return;
  locks += 1;
  if (locks > 1) return;
  const body = document.body;
  const root = document.querySelector(PHONE_ROOT_SELECTOR);
  saved = {
    scrollY: window.scrollY || window.pageYOffset || 0,
    position: body.style.position,
    top: body.style.top,
    left: body.style.left,
    right: body.style.right,
    width: body.style.width,
    overflow: body.style.overflow,
    root,
    rootOverflowY: root ? root.style.getPropertyValue("overflow-y") : "",
    rootOverflowPriority: root ? root.style.getPropertyPriority("overflow-y") : ""
  };
  if (root) {
    root.style.setProperty("overflow-y", "hidden", "important");
  } else {
    body.style.position = "fixed";
    body.style.top = `-${saved.scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
  }
  body.style.overflow = "hidden";
};

export const unlockBodyScroll = () => {
  if (typeof document === "undefined") return;
  locks = Math.max(0, locks - 1);
  if (locks > 0 || !saved) return;
  const body = document.body;
  const { root, scrollY } = saved;
  if (root) {
    if (saved.rootOverflowY) root.style.setProperty("overflow-y", saved.rootOverflowY, saved.rootOverflowPriority);
    else root.style.removeProperty("overflow-y");
  } else {
    body.style.position = saved.position;
    body.style.top = saved.top;
    body.style.left = saved.left;
    body.style.right = saved.right;
    body.style.width = saved.width;
  }
  body.style.overflow = saved.overflow;
  saved = null;
  if (!root) window.scrollTo(0, scrollY);
};

// Жест внутри окна, которому нечего прокручивать, не должен уходить в фон.
// Слушатель ставится нативно и не пассивно: у React обработчики касаний
// пассивные, и preventDefault из них не работает. Прокручиваемые области окна
// помечаются data-modal-scroll; жест над ними пропускается, если хоть одной из
// них — самой близкой или объемлющей — есть куда прокручиваться. Иначе
// короткий выпадающий список внутри длинной формы гасил и прокрутку формы.
export const useModalTouchGuard = (ref, active = true) => {
  useEffect(() => {
    const node = ref?.current;
    if (!active || !node) return undefined;
    const onTouchMove = (event) => {
      const target = event.target;
      let scroller = target?.closest?.("[data-modal-scroll]");
      while (scroller) {
        if (scroller.scrollHeight > scroller.clientHeight + 1) return;
        scroller = scroller.parentElement?.closest?.("[data-modal-scroll]") || null;
      }
      const editable = target?.closest?.("textarea, [contenteditable='true']");
      if (editable && editable.scrollHeight > editable.clientHeight + 1) return;
      event.preventDefault();
    };
    node.addEventListener("touchmove", onTouchMove, { passive: false });
    return () => node.removeEventListener("touchmove", onTouchMove);
  }, [ref, active]);
};
